<template>
  <div class="game-tr-box" :class="[{ 'position-inherit': elementTopPosition ? false : true }]" :style="setBoxStyle()">
    <div class="box-item" :style="getItemStyle(config)" v-for="(item, index) in items" :key="'item_' + index">
      <span v-if="isDelimiter(index, config)" :style="config.delimiter.cssStyle">{{ config.delimiter.text }}</span>
      <span class="item-text" v-html="item"></span>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import * as utils from '../../Utils/inputUtils';
export default {
  name: 'tr-box',
  components: {},
  props: {
    offsetVertical: {
      type: null,
      default: function () {
        return 0;
      },
    },
    offsetHorizontal: {
      type: null,
      default: function () {
        return 0;
      },
    },
    fontSize: {
      type: null,
      default: function () {
        return 'inherit';
      },
    },
    config: {
      type: null,
      default: function () {
        return {
          x: 0,
          y: 0,
          width: '100',
          height: '100',
          unit: '%',
          wordConfig: {},
          delimiter: {},
        };
      },
    },
    /**
     * example boxConfig
     * @type {Object}
     */
    // boxConfig: {
    /**
     * top
     * @type {Number}
     */
    //   y: 14,
    /**
     * left
     * @type {Number}
     */
    //   x: 25,
    /**
     * width
     * @type {Number}
     */
    //   width: 50,
    /**
     * height
     * @type {Number}
     */
    //   height: 8,
    /**
     * what unit will be used (%|px) defalt is %
     * @type {Number}
     */
    //   unit: '%',
    /**
     * data synchro; show only picked element not whole set;
     * @type {String}
     */
    //   syncData: 'syncCorrect'
    /**
     * custom CSS style
     * @type {Object}
     */
    // cssStyle: {
    //   'background-color': '#ebebeb',
    // }
    // },
    items: {
      type: null,
      default: [
        function () {
          return [];
        },
      ],
    },
  },
  // data() {
  //   return {
  //     text1: ''
  //   };
  // },
  created() {},
  mounted() {},
  methods: {
    isDelimiter(index, item) {
      return index != 0 && !_.isNil(item.delimiter);
    },
    setBoxStyle() {
      return {
        top: `${this.elementTopPosition}`,
        left: `${this.elementLeftPosition}`,
        width: `${this.elementWidth}`,
        height: `${this.elementHeight}`,
        'font-size': `${this.fontSize}`,
      };
    },
    getItemStyle(config) {
      return _.merge(this.getCustomStyle(config.wordConfig));
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
  },
  computed: {
    // TODO:poprawic box bo bezsensowna konfiguracja
    elementTopPosition() {
      return this.config && this.config
        ? utils.elementTopPosition(this.config.y, this.offsetVertical, this.config.unit)
        : undefined;
    },
    elementLeftPosition() {
      return this.config && this.config
        ? utils.elementLeftPosition(this.config.x, this.offsetHorizontal, this.config.unit)
        : undefined;
    },
    elementWidth() {
      return utils.elementWidth(this.config.width, this.config.unit);
    },
    elementHeight() {
      return utils.elementHeight(this.config.height, this.config.unit);
    },
  },
  watch: {},
};
</script>

<style lang="scss">
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';

$exampleColor: rgb(172, 231, 255);

.position-inherit {
  position: inherit;
}
.game-tr-box {
  position: absolute;
  display: flex;
  justify-content: space-around;
  align-items: center;
  // box-shadow: inset 0 0 20px 2px $firstIconColor, 0 0 20px 2px $firstIconColor;
  // border-radius: 30px;
  padding: 2%;
  width: 95%;
  background-color: $exampleColor;
  // height: 10vh;
  .box-item {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1%;
    .item-text {
      display: flex;
      justify-content: center;
      align-items: center;
      // font-size: 2.4rem;
    }
  }
}
</style>
